import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'

import App from './App'
import { AppStateProvider } from './reduxish/appState'
import { theme } from './styles/theme'
import { initNativeShell } from './api/native'
import './globals.css'

initNativeShell()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <AppStateProvider>
                <App />
            </AppStateProvider>
        </ThemeProvider>
    </React.StrictMode>,
)
